import cl from '../../styles.module.scss'
import { BasketSummary } from '../basket-summary/basket-summary'
import { BonusesPanel } from '../bonuses-panel/bonuses-panel'
import { TransferBonus } from '../transfer-bonus/ui/transfer-bonus'

type BasketSidebarProps = {
	bonusFromOrder: number
	bonusPay: number
	isJuridicalUser: boolean
	isAuthorized: boolean
	loading: boolean
}

export const BasketSidebar = ({
	bonusFromOrder,
	bonusPay,
	isJuridicalUser,
	isAuthorized,
	loading
}: BasketSidebarProps) => {
	return (
		<section className={cl.basket__sidebar}>
			<div id="mb-21-11-25" />
			{/* Summary list*/}
			<div className={cl.basket__section}>
				<BasketSummary />
			</div>
			{!!bonusFromOrder && <TransferBonus bonusCount={bonusFromOrder} isLoading={loading} />}
			{(!isJuridicalUser || !isAuthorized) && (
				<BonusesPanel
					totalBonusesCount={bonusPay}
					isAuthorized={isAuthorized}
					isJuridicalUser={isJuridicalUser}
					isLoading={loading}
				/>
			)}
		</section>
	)
}
